import Reveal from "@/components/site/Reveal";

export default function CIntroduction() {
  return (
    <section
      data-testid="c-introduction"
      className="py-24 md:py-32 bg-[#F3EEF4]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
            — Introduction
          </span>
        </Reveal>

        <div className="mt-10 grid md:grid-cols-2 gap-10 md:gap-16">
          <Reveal>
            <p className="font-serif-display text-2xl md:text-3xl leading-[1.25] text-[#1E1E2A]">
              Les constellations familiales en groupe offrent un cadre structuré
              pour explorer une problématique à travers une mise en situation.
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="md:pt-4">
              <div className="h-px w-16 bg-[#C98FA3] mb-6" />
              <p className="text-lg text-[#5F6170] leading-relaxed">
                Le groupe agit comme un espace de révélation des dynamiques
                invisibles. Ce qui se joue habituellement à l'intérieur d'une
                histoire familiale devient perceptible, lisible, ajustable.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
